import { GetStaticProps } from 'next';
import React from 'react';

import CoreLayout from '@jpp/layouts/CoreLayout';
import Policy from '@jpp/templates/Policy';
import { SITE_DESCRIPTION } from 'common/utils/constants';

const PrivacyPolicy: React.FunctionComponent = () => {
  const title = 'Privacy Policy';

  return (
    <CoreLayout title={title} description={SITE_DESCRIPTION}>
      <Policy id="9ed80ddb-b71e-4a2e-ba48-3d872f28d92b" title={title} />
    </CoreLayout>
  );
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default PrivacyPolicy;
